<template>
  <template v-if="bajaPublicidad != null">
    <div v-if="bajaPublicidad == true" class="container fs-3 mensaje">
      <h2 class="fw-bold text-primary text-center">Baja Email Publicitarios</h2>
      Ha sido dado de baja satisfactoriamente de los emails comerciales
    </div>
    <div v-else class="container fs-3 mensaje text-center">
      <h2 class="fw-bold text-primary text-center">Baja Email Publicitarios</h2>
      Ha ocurrido un error. Por favor, inténtelo más tarde.
    </div>
  </template>
</template>

<script setup>
  import UsuarioApiService from '@/services/api/skiandnight/UsuarioApiService';
  import { onBeforeMount, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useLoadingStore } from '@/store_pinia/loadingStore';

  const route = useRoute();
  const loadingStore = useLoadingStore();
  const codigo = route.params.codigo;
  const bajaPublicidad = ref();

  async function init() {
    try {
      loadingStore.show();
      UsuarioApiService.darBajaPublicidad(codigo)
      bajaPublicidad.value = true;
    } catch (error) {
      console.error(error);
      bajaPublicidad.value = false;
    } finally {
      loadingStore.hide();
    }
  }

  onBeforeMount(async () => await init());
</script>

<style lang="css" scoped>
  .mensaje {
    min-height: 60vh;
    padding-top: 12rem;
  }
</style>
